import { IMSObject, IMSId, LabelFormatSetting } from './ims-object';

export class MaterialDemand extends IMSObject {
  static fromDto(
    dto: MaterialDemandDTO,
    databag?: any,
    labelSettings?: LabelFormatSetting,
  ) {
    const obj = new this(
      {
        imsId: dto.id,
        secondaryId: dto.secondaryid,
        objRef: 'ims/MaterialDemand',
      },
      dto.label,
      labelSettings || {
        primary: {
          value: '{0}',
          databagKeys: ['label'],
        },
      },
      new IMSObject(
        dto.servicejob.id,
        undefined,
        dto.servicejob.label,
        'ims/ServiceJob',
      ),
      dto.demandstatus,
      dto.demandnumber,
      new IMSObject(
        dto.assignedemployee.id,
        undefined,
        dto.assignedemployee.label,
        'ims/Employee',
      ),
      new IMSObject(
        dto.requestedbyemployee.id,
        undefined,
        dto.requestedbyemployee.label,
        'ims/Employee',
      ),
      dto.demanddate,
      dto.extid,
    );

    if (databag) {
      obj.databag = databag;
    } else {
      obj.databag = dto;
    }

    return obj;
  }

  constructor(
    public readonly id: IMSId,
    label: string,
    labelFormatSettings: LabelFormatSetting,
    public servicejob: IMSObject,
    public demandStatus: string,
    public demandNumber: string,
    public assignedEmployee: IMSObject,
    public requestedByEmployee: IMSObject,
    public demandDate: number,
    public extId: string,
  ) {
    super(
      id.imsId,
      id.secondaryId,
      label,
      'ims/MaterialDemand',
      labelFormatSettings,
    );
  }
}

export interface MaterialDemandDTO {
  id: number;
  secondaryid: number;
  label: string;
  servicejob: {
    id: number;
    label: string;
  };
  demandstatus: string;
  demandnumber: string;
  demanddate: number;
  assignedemployee: {
    id: number;
    label: string;
  };
  requestedbyemployee: {
    id: number;
    label: string;
  };
  extid: string;
}
